import packageJson from 'package.json';
import {CloudName, CloudType, Environment} from '@q9elements/ui-kit/common';

export const environment: Environment = {
    version: packageJson.version,
    API_ENDPOINT: 'https://loadtest-api.q9elements.com/api/v1', 
    API_STATIC_FILE_UPLOAD: 'https://loadtest-upload.q9elements.com:1443/api',
    APPNAME: 'HD-APP',
    CLOUD_NAME: CloudName.ELEMENTS,
    CLOUD_TYPE: CloudType.PUBLIC,
    DATA_STRUCTURE_URL: 'https://loadtest-datatable.q9elements.com',
    DIAGRAM_URL: 'https://loadtest-diagram.q9elements.com',
    DOMAIN: 'q9elements.com',
    ENTERPRISE_URL: 'https://loadtest-corp.q9elements.com',
    ENV: 'loadtest',
    GDPR_SUPPORT_LINK: 'https://support.elements.cloud/en/articles/1221094-enable-data-privacy-gdpr-compliance-for-a-ref-model',
    IMPORT_MAP_API: 'https://loadtest-gateway.q9elements.com/map-import/api/v1',
    IMPORTS_API: 'https://loadtest-gateway.q9elements.com/import/api/v1',
    INTERCOM_APP_ID: 'sfi4u1en',
    MAIN_APP_URL: 'https://loadtest-app.q9elements.com',
    MAP_MANAGEMENT_APP: 'https://loadtest-mapmgt.q9elements.com',
    NO_IMAGE_URL: '../../assets/images/no_image.png',
    PARTNER_APP: 'https://loadtest-partnermgt.q9elements.com', 
    PREVIEW_HOLDER: '/assets/images/map_placeholder.png', 
    production: true, 
    SENTRY_AUTH_TOKEN: '',
    SENTRY_DSN: '',
    SENTRY_ORG: '',
    SENTRY_PROJECT: 'main-app',
    REF_MODEL_APP: 'https://loadtest-refmodel.q9elements.com',
    RELEASE_URL: 'https://loadtest-releasemgt.q9elements.com',
    REMOTE_UNLOCK_TTL: 3600000,
    REPORTS_API_ENDPOINT: 'https://loadtest-gateway.q9elements.com/report/api/v1',
    REPORTS_APP: 'https://loadtest-report.q9elements.com',
    SALESFORCE_CLIENT_ID: '3MVG9Rd3qC6oMalVszZtK2Usdv9bqy4_doe6P1BuqzckkUu1t0JC1aW.e13T.i_8rQ3P8A9goskWvf4iLeabN',
    SALESFORCE_REDIRECT_URL: 'https://loadtest-app.q9elements.com/auth/callback',
    SALESFORCE_URL_TEST: 'https://test.salesforce.com/services/oauth2/authorize',
    SALESFORCE_URL: 'https://login.salesforce.com/services/oauth2/authorize',
    SECURE_COOKIES: true,
    SYS_ADMIN_APP: 'https://loadtest-sysadmin.q9elements.com',
    TEAM_APP: 'https://loadtest-spacemgt.q9elements.com',
    STATIC_FILES_URL: 'https://static.elements-eng.cloud',
    TOASTR_TIMEOUT: 5000,
    UNLOCK_TTL: 180000,
    JAM_TEAM_ID: '',
    MCP_OAUTH_URL: 'https://loadtest-api.q9elements.com/api/v1/oauth',
    fbConfig: {
        apiKey:'AIzaSyC1scjCnEIl0p3hNSXPd7xv0gZInlcwr6M',
        authDomain:'elements-loadtest.firebaseapp.com',
        databaseURL: 'https://elements-loadtest-default-rtdb.firebaseio.com/',
        projectId: 'elements-loadtest',
        appId: '1:201990050997:web:3b9c59c614dcc81aea1afc'
    }
};
